import React, { useState, useEffect } from 'react';
import SavedAddressesItem from '@components/SavedAddressesItem';
import * as Styled from './SavedAddresses.styles';

import { translate as t } from '@utils/translate';

const SavedAddresses = ({ data, onPick }) => {
  const [itemSelected, setItemSelected] = useState(null);
  const TEXTS = {
    SAVED_ADDRESSES: t('savedAddresses'),
  };

  useEffect(() => {
    onPick(itemSelected);
  }, [itemSelected]);

  function pickAddress(id) {
    setItemSelected(id !== itemSelected ? id : null);
  }

  return (
    <Styled.Wrapper>
      <Styled.Title>{TEXTS.SAVED_ADDRESSES}</Styled.Title>
      {data.length &&
        data.map((address, index) => {
          return (
            <SavedAddressesItem
              data-test={`address.saved-${index}`}
              onSelect={pickAddress}
              isHighlighted={itemSelected === address.id}
              key={address.id}
              data={address}
            />
          );
        })}
    </Styled.Wrapper>
  );
};

export default SavedAddresses;
